var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "13.159 17.17 173.683 165.66",
    style: {
      stroke: "rgba(255, 203, 5, 1)",
      strokeWidth: 10,
      fill: "rgba(255, 203, 5, 1)"
    },
    viewBox: "0 0 200 200",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "shape",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.368 19.886l23.062 46.728a4.872 4.872 0 0 0 3.668 2.665l51.567.257c3.996.581 5.591 5.491 2.7 8.309l-37.314 43.608a4.872 4.872 0 0 0-1.401 4.312l17.152 51.359c.683 3.979-3.494 7.014-7.068 5.135l-54.467-24.248a4.873 4.873 0 0 0-4.534 0L45.022 182.26c-3.574 1.879-7.751-1.156-7.068-5.135l15.397-51.359a4.872 4.872 0 0 0-1.401-4.312L14.635 79.203c-2.891-2.818-1.296-7.729 2.7-8.309l51.567-1.615a4.872 4.872 0 0 0 3.668-2.665l23.062-46.728c1.787-3.621 6.949-3.621 8.736 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.eb86921ef6e74d17ad6a7f752f35c63f.svg";
export { ForwardRef as ReactComponent };